import { createContext, useContext } from 'react';
import { FilterContextValue } from './types';

export const FilterContext = createContext<FilterContextValue | undefined>(undefined);

export function useFilterContext() {
  const value = useContext(FilterContext);
  if (!value) throw new Error('useFilterContext should be used inside a FilterContextProvider component.');

  return value;
}
